module.exports = __webpack_public_path__ + "static/media/pattern2.7cfda5d5.png";